<template>
    <div class="multiple-switcher">
        <div
            v-for="(option, key) in switcherOptions"
            v-show="option.isEnabled && !option.isHidden"
            class="multiple-switcher__item"
            :key="option.value"
        >
            <button
                class="multiple-switcher__button"
                :class="{ 'multiple-switcher__button--selected': isSelected(option) }"
                @click="selectOption(option)"
            >
                <div class="multiple-switcher__button-content">
                    <Icon
                        v-if="option.iconClass"
                        :class="option.iconClass"
                    />
                    <div class="multiple-switcher__button-content-text capitalize">
                        {{ `${$t(option.label)}` }}
                    </div>
                    <div class="multiple-switcher__button-content-check">
                        <Icon
                            size="md"
                            :class="isSelected(option) ? 'icon-check' : 'icon-check_circle_empty'"
                        />
                    </div>
                </div>
                <slot :name="key" />
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MultipleSwitcher',
        emits: ['change'],
        props: {
            switcherOptions: {
                type: Object,
                required: true,
            },
            value: {
                type: String,
                default: null,
            },
        },
        methods: {
            selectOption(option) {
                this.$emit('change', option.value);
            },
            isSelected(option) {
                return this.value === option.value;
            },
        },
    };
</script>
